import React, { useEffect, useState } from "react";
import PickingListDetailtable, {
  ProductImageCell,
} from "./PickingListDetailtable";
function PickingListDetaildata() {
 

  const data = [
    {
      id: "1",
      order:"1",
      number: "10254354545",
      itemname: "Dutch Grown",
      stock: "1",
    },
    {
      id: "2",
      order:"1",
      number: "10254354545",
      itemname: "Cambo",
      stock: "1",
    },
    {
      id: "3",
      order:"1",
      number: "10254354545",
      itemname: "Avon Bulbs",
      stock: "2",
    },
    {
      id: "4",
      order:"1",
      number: "10254354545",
      itemname: "Broardleight Bulbs",
      stock: "4",
    },
    {
      id: "5",
      order:"1",
      number: "10254354545",
      itemname: "Dutch Grown",
      stock: "10",
    },
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "Assembly Order",
        accessor: "order",
      },

      {
        Header: "Number",
        accessor: "number",
      },
      {
        Header: "Item Name",
        accessor: "itemname",
      },
     

      {
        Header: "Image",
        accessor: "img",
        Cell: ProductImageCell,
      },

      {
        Header: "QTY",
        accessor: "stock",
      
      },     
      {
        Header: "Report",
        accessor: "report",
        Cell: (value) => (
          <div>
         

          <button className="float-right mt-3"
          >
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 12.1815C15 13.8391 13.654 15.1881 12 15.1881C10.346 15.1881 9 13.8391 9 12.1815C9 10.5239 10.346 9.17498 12 9.17498C13.654 9.17498 15 10.5239 15 12.1815ZM24 11.7315C24 11.7315 19.748 20.199 12.015 20.199C4.835 20.199 0 11.7315 0 11.7315C0 11.7315 4.446 4.16406 12.015 4.16406C19.709 4.16406 24 11.7315 24 11.7315ZM17 12.1815C17 9.41851 14.757 7.17061 12 7.17061C9.243 7.17061 7 9.41851 7 12.1815C7 14.9445 9.243 17.1924 12 17.1924C14.757 17.1924 17 14.9445 17 12.1815Z"
                fill="#1F78B4"
              />
            </svg>
          </button>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <PickingListDetailtable
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default PickingListDetaildata;
